import { ApiResult } from 'interfaces/APITypes';

import { ServerSideFilter } from 'components/mytover/invite/UnitUserFilterSection';

import { contentInstance, makeRequest } from './client';

export const getUser = async (id?: string): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/users/${id}`));
};

export const getSetsForUser = async (id: string): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/users/${id}/content-sets`));
};

// The backend route is named (and served at) `logs`, not `activity` - see
// routes/tover_lab.php's `users.` group.
export const getUserActivity = async (id?: number | string, values?: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/users/${id}/logs`, { params: values }));
};
